import { ProprieteAffichee } from "../proprieteAffichee";

export class RockType {
    id: number;
    name:string;
    siteId:number;
    compressiveStrength: number;
    youngModulus:number;
    shearModulus: number;
    rqd: number;
    density: number;
    theoreticalSpeed: number;
    poissonRatio: number;



    getProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('id', 'GLOBAL.IDENTIFICATEUR'));
        tab.push(new ProprieteAffichee('name', 'GLOBAL.NOM'));
        tab.push(new ProprieteAffichee('compressiveStrength', 'ROCK_TYPE.COMPRESSIVE_STRENGTH'));
        tab.push(new ProprieteAffichee('youngModulus', 'ROCK_TYPE.YOUNG_MODULUS'));
        tab.push(new ProprieteAffichee('shearModulus', 'ROCK_TYPE.SHEAR_MODULUS'));
        tab.push(new ProprieteAffichee('theoreticalSpeed', 'ROCK_TYPE.THEORETICAL_SPEED'));
        tab.push(new ProprieteAffichee('poissonRatio', 'ROCK_TYPE.POISSON_RATIO'));
        tab.push(new ProprieteAffichee('rqd', 'ROCK_TYPE.RQD'));
        tab.push(new ProprieteAffichee('density', 'ROCK_TYPE.DENSITY'));
        return tab;
      }

  }



